<template>
 <div class="center content-inputs mt-5">{{$store.state.auth.userInfo}}
   <form class="login text-center" @submit.prevent="login">
      <h3>تسجيل الدخول</h3><br>
     <div class="row  justify-content-center">
     <vs-input v-model="email" placeholder="إسم المستخدم" required class="m-2 animate__animated animate__zoomIn">
        <template #icon>
          <i class='fa fa-user'></i>
        </template>
      </vs-input>

      <vs-input type="password" icon-after v-model="password" placeholder="كلمة المرور" required class="m-2 animate__animated animate__zoomIn animate__delay-1s">
        <template #icon>
          <i class='fa fa-lock'></i>
        </template>
      </vs-input>

      <vs-button    type="submit"  class="d-block" @click="login"> دخول</vs-button>
     </div>
   </form>
 </div>
</template>
<script>
  export default {
    data(){
      return {
        email : "",
        password : ""
      }
    },
    methods: {
      login: function () {
        let username = this.email
        let password = this.password
        this.$store.dispatch('auth/login', { username, password }).then(res => {
         if (res.status==200 || res.status==201) {
              this.$vs.notify({
                            color: 'success',
                            title: 'login successful',
                            text: ` Welcome ${res.data.user.name}`
                        })
            this.$router.push('/')
         }else{
            console.log(res);
         }
         
       })
       .catch(err =>{
         console.log("error4 "+err);
       })
      }
    }
  }
</script>